import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { StaffSearch } from './staff-search';
import { StaffDetails } from './staff-details';
import { Helmet } from 'react-helmet';

// This is named staff-page because it clashes with the Staff component in index.tsx
export const Staff: React.FC<any> = (_props) => {
  return (
    <>
      <Helmet>
        <title>Staff</title>
      </Helmet>
      <Routes>
        <Route path="*" element={<StaffSearch />} />
        <Route path=":staffId/staff-details/*" element={<StaffDetails />} />
      </Routes>
    </>
  );
};
